<template>
  <div class="big">
    <el-dialog
      title="项目订单"
      :visible.sync="dialog"
      width="800px"
      style="text-align: left"
    >
      <div class="dialog">
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="orderData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="患者姓名"
              prop="user_name"
            ></el-table-column>

            <el-table-column label="性别">
              <template slot-scope="scope">
                <span v-if="scope.row.sex == 1">男</span>
                <span v-if="scope.row.sex == 2">女</span>
                <span v-if="scope.row.sex == 0">未知</span>
              </template>
            </el-table-column>
            <el-table-column
              label="年龄"
              prop="age"
            ></el-table-column>
            <el-table-column label="订单状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 1">未支付</div>
                <div v-if="scope.row.status == 2">已支付</div>
                <div v-if="scope.row.status == 3">已支付</div>
                <div v-if="scope.row.status == 4">已完成</div>
                <div v-if="scope.row.status == 5">已作废</div>
                <div v-if="scope.row.status == 6">已作废</div>
              </template>
            </el-table-column>

            <el-table-column
              label="支付时间"
              prop="pay_time"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.pay_time_date }}</div>
                <div>{{ scope.row.pay_time_time }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="完成时间"
              prop="completion_time"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.completion_time_date }}</div>
                <div>{{ scope.row.completion_time_time }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <div class="page_title">推荐记录列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox">
              <div class="item">
                <span>医生姓名</span>
                <el-input
                  placeholder="请输入"
                  v-model="doctor_name"
                  style="width: 140px; margin-left: 12px"
                  @input="search"
                ></el-input>
              </div>
              <div class="item">
                <span>推荐时间</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 264px; margin-left: 12px"
                  @change="search"
                ></el-date-picker>
              </div>
              <div class="item">
                <span>项目类型</span>
                <el-select
                  v-model="pro_type"
                  placeholder="请选择"
                  @change="search"
                  style="width: 160px; margin-left: 12px"
                  clearable
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="item">
                <span>项目名称</span>
                <el-input
                  placeholder="请输入"
                  v-model="pro_name"
                  style="width: 140px; margin-left: 12px"
                  @input="search"
                ></el-input>
                <el-button
                  type="info"
                  style="
                    background-color: #eceff2;
                    color: #747981;
                    margin-left: 10px;
                  "
                  @click="search"
                >查询</el-button>
              </div>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  label="推荐时间"
                  prop="recommend_time"
                ></el-table-column>

                <el-table-column label="医生信息">
                  <template slot-scope="scope">
                    <div>{{ scope.row.doctor_name }}</div>
                    <div>
                      <span v-if="scope.row.sex == 1">男</span>
                      <span v-if="scope.row.sex == 2">女</span>
                      <span v-if="scope.row.sex == 0">未知</span>
                      <span style="margin-left: 15px">{{
                        scope.row.title
                      }}</span>
                    </div>
                    <div>{{ scope.row.phone }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="项目类型">
                  <template slot-scope="scope">
                    <div v-if="scope.row.pro_type == 1">体检项目</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="项目名称"
                  prop="pro_name"
                ></el-table-column>
                <el-table-column
                  label="销售价格"
                  prop="price"
                ></el-table-column>

                <el-table-column
                  prop="order_count"
                  label="推荐产生订单数"
                >
                  <template slot-scope="scope">
                    <div
                      v-if="scope.row.order_count"
                      style="color: #027dc5; cursor: pointer"
                      @click="orderDetail(scope.row.recommend_id)"
                    >
                      {{ scope.row.order_count }}
                    </div>
                    <div v-else>0</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import marketing from '../../../api/marketing';
import platform from '../../../api/platform';
import moment from 'moment';
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      doctor_name: '',
      pro_type: '',
      pro_name: '',
      date: [],
      tableData: [],
      options: [
        {
          label: '体检项目',
          value: 1
        }
      ],
      dialog: false,
      orderData: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        pro_type: this.pro_type,
        pro_name: this.pro_name,
        start_time: '',
        end_time: ''
      };
      if (this.date && this.date.length > 0) {
        data.start_time = moment(this.date[0]).format('YYYY-MM-DD');
        data.end_time = moment(this.date[1]).format('YYYY-MM-DD');
      }
      marketing.getDoctorRecommendLists(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.recommend_time = moment
              .unix(item.recommend_time)
              .format('YYYY-MM-DD HH:mm:ss');
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },

    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //查看产生订单详情
    orderDetail(recommend_id) {
      marketing.getDoctorRecommendDetails({ recommend_id }).then((res) => {
        if (res.code == 0) {
          this.orderData = res.data.map((item) => {
            if (item.pay_time) {
              item.pay_time_date = moment
                .unix(item.pay_time)
                .format('YYYY-MM-DD');
              item.pay_time_time = moment
                .unix(item.pay_time)
                .format('HH:mm:ss');
            }
            if (item.completion_time) {
              item.completion_time_date = moment
                .unix(item.completion_time)
                .format('YYYY-MM-DD');
              item.completion_time_time = moment
                .unix(item.completion_time)
                .format('HH:mm:ss');
            }

            return item;
          });
          this.dialog = true;
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 1px 20px;
  .searchbox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .item {
      margin-right: 30px;
      margin-top: 24px;
      display: flex;
      align-items: center;
    }
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.dialog {
  padding: 20px;
}
</style>
